import { Copy, Check } from "lucide-react";
import { useState } from "react";
import SEO from "@/components/SEO";

const EMAIL = "alekzsounds@gmail.com";

const SOCIALS = [
  { name: "Instagram", href: "https://www.instagram.com/alekzsoto", testId: "contact-instagram" },
  { name: "Spotify", href: "https://open.spotify.com/artist/3EYFamAYwkxnirfWB7IkBn", testId: "contact-spotify" },
  { name: "Apple Music", href: "https://music.apple.com/us/artist/alekz/1715908465", testId: "contact-apple" },
  { name: "Linktree", href: "https://linktr.ee/alekzsoto", testId: "contact-linktree" },
];

export default function Contact() {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      // noop
    }
  };

  return (
    <section
      className="relative min-h-screen pt-32 sm:pt-40 px-6 sm:px-10 lg:px-14 pb-24"
      data-testid="contact-page"
    >
      <SEO
        path="/contact"
        title="Contact"
        description="Contact ALEKZ (Alex Soto) for bookings and inquiries — alekzsounds@gmail.com. Instagram, Spotify, Apple Music."
      />
      <div className="max-w-4xl mx-auto">
        <h2
          className="font-display text-white leading-[0.95]"
          style={{ fontSize: "clamp(3rem, 9vw, 7rem)", letterSpacing: "-0.01em" }}
          data-testid="contact-title"
        >
          Contact
        </h2>

        <div className="mt-10 h-px bg-[var(--hairline-strong)] line-grow" />

        <div className="mt-16">
          <p className="font-mono-wide text-[10px] tracking-[0.4em] text-[var(--silver-soft)]">
            Bookings · Direct
          </p>
          <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-5">
            <a
              href={`mailto:${EMAIL}`}
              data-testid="contact-email-link"
              className="font-display text-white leading-none hover:opacity-80 transition-opacity"
              style={{ fontSize: "clamp(1.75rem, 4vw, 3rem)" }}
            >
              {EMAIL}
            </a>
            <button
              onClick={copyEmail}
              data-testid="contact-copy-email"
              className="silver-chip inline-flex items-center gap-2 px-4 py-2 rounded-full font-mono-wide text-[10px] tracking-[0.4em] self-start"
            >
              {copied ? (
                <>
                  <Check className="w-3 h-3" /> Copied
                </>
              ) : (
                <>
                  <Copy className="w-3 h-3" /> Copy
                </>
              )}
            </button>
          </div>
        </div>

        <div className="mt-20">
          <p className="font-mono-wide text-[10px] tracking-[0.4em] text-[var(--silver-soft)] mb-6">
            Elsewhere
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[var(--hairline)]">
            {SOCIALS.map((s) => (
              <li key={s.name} className="bg-black">
                <a
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={s.testId}
                  className="group flex items-center justify-between px-6 py-6 hover:bg-white/[0.03] transition-colors"
                >
                  <span className="font-display text-2xl sm:text-3xl text-white">
                    {s.name}
                  </span>
                  <span className="font-mono-wide text-[10px] tracking-[0.4em] text-[var(--silver-soft)] group-hover:text-white transition-colors">
                    Open →
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
